var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{staticClass:"view-on-github",attrs:{"href":_vm.githubViewsUrl + _vm.$route.path + '.vue',"target":"_blank"}},[_vm._v(" 在 Github 上查看 "+_vm._s(_vm.$route.path)+".vue ")])
}
var staticRenderFns = []

export { render, staticRenderFns }